import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from 'core/services';
import { ContractsModel } from 'core/models/contracts.model';

@Injectable({
    providedIn: 'root',
})
export class ApiContractsService extends ApiListDataService<ContractsModel, any> {
    constructor(http: HttpClient) {
        super(http, '/Contract/webregister');
    }
}

@Injectable({
    providedIn: 'root',
})
export class ApiContractService extends ApiListDataService<any, any> {
    constructor(http: HttpClient) {
        super(http, '/Contract/');
    }
}

@Injectable({
    providedIn: 'root',
})
export class ApiContractForSubRecipientService extends ApiListDataService<any, any> {
    constructor(http: HttpClient) {
        super(http, '/Contract/ContractForSubRecipient/Lookup/');
    }
}
